import _ from 'lodash';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import { connect } from 'react-redux';

import CampaignCard       from 'app/components/common/campaign-card';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import NteePicker         from 'app/components/common/ntee-picker';
import Pagination         from 'app/components/common/pagination';
import StandardInput      from 'app/components/common/standard-input';
import StandardSelect     from 'app/components/common/standard-select';
import ModalSort          from 'app/components/company-admin/campaigns/modal-sort-templates';
import CadminLayout       from 'app/components/company-admin/layout/';
import PageLoading        from 'app/components/layout/page-loading';
import {
  CampaignTempTypes as Types,
}                         from 'app/constants';
import PageDuck           from 'app/ducks/company-admin/page-campaigns-templates';
import history            from 'app/history';
import paths              from 'app/paths';
import CadminSlx          from 'app/selectors/company-admin/';
import RoutingSlx         from 'app/selectors/routing';



const typeOpts = [
  {label: 'Emergency Response', value: Types.EMERGENCY},
  {label: 'Trending',           value: Types.ONE_OFF},
  {label: 'Evergreen',          value: Types.EVERGREEN},
  {label: 'Seasonal',           value: Types.RECURRING},
];

const activityOpts = [
  {label: 'Donations',    value: 'give'},
  {label: 'Volunteering', value: 'vol'},
  {label: 'Goods Drive',  value: 'drive'},
];

class PageCadminCampaignsTemplates extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      showSortModal: false,
    };

    this.onChangeNtee = this.onChangeNtee.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onChangeType = this.onChangeType.bind(this);
    this.onChangeActivity = this.onChangeActivity.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);
    this.onClickSort = this.onClickSort.bind(this);
    this.onCloseSort = this.onCloseSort.bind(this);
  }

  onChangeNtee(nteeCode) {
    this.setParams({nteeCode});
  }

  onChangeSearch(event) {
    const search = event.target.value;
    this.setParams({search});
  }

  onChangeType(type) {
    this.setParams({type});
  }

  onChangeActivity(activity) {
    this.setParams({activity});
  }

  onSelectPage(page) {
    this.setParams({page});
  }

  onClickSort() {
    this.setState({showSortModal: true});
  }
  onCloseSort(didUpdate) {
    this.setState({showSortModal: false});
    if (didUpdate) {
      window.location.href = window.location.href;
    }
  }

  setParams(params) {
    const prevParams = this.props.query;
    const newParams = {...prevParams, page: null, ...params};
    const path = paths.cadminCampaignTemplates(this.props.company.slug, newParams);
    history.push(path);
  }

  get isSystemEvents() {
    return !!this.props.company?.isSystemEvents;
  }

  renderFilters() {
    const {params} = this.props;

    return (
      <div className="ca-main-filters">
        <div className="ca-main-filters-filter">
          <label className="ca-main-filters-filter-label">Category</label>
          <NteePicker nteeCode={params.nteeCode} onChange={this.onChangeNtee} allowClear allowMajor onlyMajor label="Any" />
        </div>
        <div className="ca-main-filters-filter">
          <label className="ca-main-filters-filter-label">Type</label>
          <StandardSelect options={typeOpts} value={params.type} onSelect={this.onChangeType} allowClear label="Any" />
        </div>
        <div className="ca-main-filters-filter">
          <label className="ca-main-filters-filter-label">Activity</label>
          <StandardSelect options={activityOpts} value={params.activity} onSelect={this.onChangeActivity} allowClear label="Any" />
        </div>
        <div className="ca-main-filters-filter">
          <label className="ca-main-filters-filter-label">Search</label>
          <StandardInput value={params.search || ''} onChange={this.onChangeSearch} name="search" label="Type to search..." />
        </div>
      </div>
    );
  }

  renderCampaigns() {
    const {company, campaigns} = this.props;
    if (!campaigns) return <Icon.Loading className="ca-campaigns-loading" />;
    if (!campaigns?.length) return <p>No results. Try clearing some filters.</p>;

    return (
      <div className="ca-campaigns-section-live-campaigns">
        <div className="ca-campaigns-section-live-campaigns-cards">
          {campaigns.map(camp => {
            const href = this.isSystemEvents ? paths.cadminCampaignsView(company.slug, camp.id) : null;
            return (
              <div key={camp.id} className="campaigns-cards-card">
                <CampaignCard campaign={camp} isTemplate companySlug={company.slug} href={href} />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    const {company, allCampaigns, campaigns, params, pagination} = this.props;
    const {showSortModal} = this.state;
    if (!company) return <PageLoading />;

    return (
      <CadminLayout className="ca-campaigns" company={company} activeItem="campaign-templates" dnd>
        <Meta title="Campaigns | Millie" />

        <div className="ca-main-head">
          <h1 className="ca-main-head-h1 gradient-pink-purple-text"><Icon.DesignToolsPenStation className="_clr-pink" /> Campaign Template Library</h1>
          {this.isSystemEvents && (
            <div className="ca-main-head-actions">
              <button className="btn blue" onClick={this.onClickSort}>Sort</button>
              <Link className="btn blue" href={paths.cadminNewCampaign(company.slug)}>New Template</Link>
            </div>
          )}
        </div>

        {this.renderFilters()}

        {this.renderCampaigns()}

        <br /><br />
        {pagination && (
          <Pagination pagination={pagination} onSelectPage={this.onSelectPage} />
        )}

        {showSortModal && (
          <ModalSort onClose={this.onCloseSort} allCampaigns={allCampaigns} />
        )}
      </CadminLayout>
    );
  }

}

const stateToProps = (state) => ({
  company: CadminSlx.company(state),
  query: RoutingSlx.query(state),

  allCampaigns: PageDuck.Slx.allCampaigns(state),
  campaigns: PageDuck.Slx.pagedCampaigns(state),
  params: PageDuck.Slx.params(state),
  pagination: PageDuck.Slx.pagination(state),
});

const dispatchToProps = (dispatch) => ({
});

export default connect(stateToProps, dispatchToProps)(PageCadminCampaignsTemplates);
